import {findFieldMetadata} from "../common/Metadata";
import * as FieldType from '../constants/FieldType'
import * as CommonConstants from '../constants/CommonConstants'
import * as DataTypes from '../constants/DataTypes'
import {stringify} from "../common/NamaJSON";
import {BOOLEAN} from "../constants/DataTypes";
/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function bigDecimal(fieldId, val) {
    return {
        dataType: DataTypes.BIGDECIMAL,
        fieldId: fieldId,
        bigDecimalData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function text(fieldId, val) {
    return {
        dataType: DataTypes.STRING,
        fieldId: fieldId,
        textData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function boolean(fieldId, val) {
    return {
        dataType: DataTypes.BOOLEAN,
        fieldId: fieldId,
        booleanData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function integer(fieldId, val) {
    return {
        dataType: DataTypes.INTEGER,
        fieldId: fieldId,
        integerData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function date(fieldId, val) {
    return {
        dataType: DataTypes.DATE,
        fieldId: fieldId,
        dateData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function long(fieldId, val) {
    return {
        dataType: DataTypes.LONG,
        fieldId: fieldId,
        longData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function reference(fieldId, val) {
    return {
        dataType: DataTypes.ENTITYREFERENCE,
        fieldId: fieldId,
        entityReferenceData: val
    };
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
export function list(fieldId, val, parentDetail) {
    return {
        dataType: DataTypes.NORMALLIST,
        fieldId: fieldId,
        listData: {dataType: DataTypes.NORMALLIST, parantDetail: parentDetail, list: val}
    };
}

/**
 *
 * @param {namaTypes.GenericValue}genericValue
 * @return {*}
 */
export function getValue(genericValue) {
    switch (genericValue.dataType) {
        case DataTypes.BIGDECIMAL:
            return genericValue.bigDecimalData;
        case DataTypes.STRING:
            return genericValue.textData;
        case DataTypes.BOOLEAN:
            return genericValue.booleanData;
        case DataTypes.INTEGER:
            return genericValue.integerData;
        case DataTypes.DATE:
            return genericValue.dateData;
        case DataTypes.LONG:
            return genericValue.longData;
        case DataTypes.ENTITYREFERENCE:
            return genericValue.entityReferenceData;
        case DataTypes.NORMALLIST:
        case DataTypes.FLATOBJECT:
        case DataTypes.FLATOBJECTLIST:
            return genericValue.realFlatObject;
        case DataTypes.ATTACHMENT:
            return genericValue.attachmentInfo;
    }
    return genericValue.jsonData;
}

/**
 *
 * @param {string} fieldId
 * @param {namaTypes.EntityTypeMetaData} entityMetaData
 * @param value
 * @return {namaTypes.GenericValue}
 */
export function createGenericValue(fieldId, entityMetaData, value, row) {
    let fieldMetadata = findFieldMetadata(fieldId, entityMetaData);
    if (!fieldMetadata || !fieldMetadata.fieldType)
        return createGenericValueBasedOnTheValue(fieldId, value);
    let fieldType = fieldMetadata.fieldType;
    if (fieldType === FieldType.Detail && row !== undefined && row !== null)
        return createGenericValueForObject(fieldId, value, entityMetaData.owner.ownerId);
    return createGenericValueForType(fieldId, value, fieldType)
}

/**
 *
 * @param {string} fieldId
 * @param value
 * @return {namaTypes.GenericValue}
 */
export function createGUI2GenericValue(fieldId, value, dataType) {
    return {
        dataType: dataType,
        fieldId: fieldId,
        jsonData: stringify(value)
    }
}

/**
 *
 * @param fieldId
 * @param value
 * @return {namaTypes.GenericValue}
 */
export function createGenericValueBasedOnTheValue(fieldId, value) {
    if (value === undefined || value === null)
        return {fieldId: fieldId, dataType: DataTypes.STRING};
    if (value === true || value === false)
        return {fieldId: fieldId, dataType: DataTypes.BOOLEAN, textData: value};
    if (value.entityType)
        return createReferenceGenericValue(fieldId, value);
    return {fieldId: fieldId, dataType: DataTypes.STRING, textData: value};
}
export function createSelectRowIndexValue(selectedRow) {
    return createGenericValueForType(CommonConstants.CONTEXTFIELD_SELECTEDLINE_INDEX, selectedRow, FieldType.Integer);
}

export function createWholeEntityValue(fieldId, object, entityType) {
    return {
        dataType: DataTypes.GUI2WholeEntity,
        fieldId: fieldId,
        gui2EntityType: entityType,
        jsonData: stringify(object)
    }
}

export function createReferenceGenericValue(fieldId, object) {
    return {
        dataType: DataTypes.ENTITYREFERENCE,
        fieldId: fieldId,
        entityReferenceData: object
    }
}
export function createGenericValueForList(fieldId,value,gui2ListType) {
    if (!Array.isArray(value))
        value = [value];
    return {
        dataType: DataTypes.GUI2List,
        fieldId: fieldId,
        jsonData: stringify(value),
        gui2ClassName: gui2ListType
    }
}

export function createGenericValueForObject(fieldId, value, entityType, gui2ClassName) {
    return {
        dataType: DataTypes.GUI2FlatObject,
        fieldId: fieldId,
        jsonData: value ? (typeof value == 'string') ? value : stringify(value) : null,
        gui2EntityType: entityType,
        gui2ClassName: gui2ClassName
    }
}
export function createGenericValueForType(fieldId, value, fieldType, parentDetail) {
    if (!fieldType)
        return createGenericValueBasedOnTheValue(fieldId, value);
    switch (fieldType) {
        case FieldType.Decimal:
            return bigDecimal(fieldId, value);
        case FieldType.BigText:
        case FieldType.Enum:
        case FieldType.ID:
        case FieldType.EntityType:
        case FieldType.Link:
        case FieldType.Email:
        case FieldType.Measures:
        case FieldType.Password:
        case FieldType.FieldID:
        case FieldType.FeatureID:
        case FieldType.LatLng:
        case FieldType.Color:
        case FieldType.PhoneNumber:
        case FieldType.Text:
            return text(fieldId, value);
        case FieldType.Boolean:
            return boolean(fieldId, value);
        case FieldType.Integer:
            return integer(fieldId, value);
        case FieldType.Long:
            return long(fieldId, value);
        case FieldType.Time:
        case FieldType.DateAndTime:
        case FieldType.Date:
            return date(fieldId, value);
        case FieldType.Genericreference:
        case FieldType.Reference:
            return reference(fieldId, value);
        case FieldType.Detail:
            return list(fieldId, value, parentDetail);
        case FieldType.Binary:
            return attachment(fieldId, value);

    }
    return text(fieldId, value);
}

/**
 *
 * @param fieldId
 * @param val
 * @return {namaTypes.GenericValue}
 */
function attachment(fieldId, val) {
    return {
        dataType: DataTypes.ATTACHMENT,
        fieldId: fieldId,
        attachmentInfo: val ? val.attachmentInfo : null
    };
}

function timeToInt(str) {
    if (!str || !str.length)
        return 0;
    var parts = str.split(/:/);
    return (parts[0] * 60 * 60 * 1000) + (parts[1] * 60 * 1000);
}

function intToTime(msValue) {
    var milliseconds = parseInt((msValue % 1000) / 100)
        , seconds = parseInt((msValue / 1000) % 60)
        , minutes = parseInt((msValue / (1000 * 60)) % 60)
        , hours = parseInt((msValue / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
}
